"use strict";

exports.__esModule = true;
exports["default"] = jsonToJsonString;

var _lodash = require("lodash");

var _cleanUpTeselagenJsonForExport = _interopRequireDefault(require("./utils/cleanUpTeselagenJsonForExport"));

var _veSequenceUtils = require("ve-sequence-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @param {*} incomingJson
 * @returns a sequence json cleaned up and converted to a string with extranous fields ommited
 */
function jsonToJsonString(incomingJson) {
  return JSON.stringify((0, _lodash.omit)((0, _cleanUpTeselagenJsonForExport["default"])((0, _veSequenceUtils.tidyUpSequenceData)(incomingJson, {
    annotationsAsObjects: false
  })), ["sequenceFragments", "sequenceFeatures", "cutsites", "orfs", "filteredParts", "filteredFeatures"]));
}

module.exports = exports.default;